var animation = { duration: 20000, easing: (t) => t };

var rollingBanner = new KeenSlider('#rolling-banner', {
  loop: true,
  drag: false,
  rtl: false,
  slides: { perView: 'auto' },
  created(s) {
    s.moveToIdx(5, true, animation);
  },
  updated(s) {
    s.moveToIdx(s.track.details.abs + 5, true, animation);
  },
  animationEnded(s) {
    s.moveToIdx(s.track.details.abs + 5, true, animation);
  },
});